/**
 * Extra `fields.listing` paths for Sharetribe listing queries when using sparse fieldsets.
 * {@link ListingCard} needs description plus category-related `publicData` keys (see `deriveTags`
 * in ListingCard.js) — without these, search / featured grids show empty description and tags.
 *
 * @param {Object|null|undefined} categoryConfiguration merged config from listing-categories asset
 *        (`key` prefix + `categories` tree)
 * @returns {string[]}
 */
export const getListingCardExtraQueryFields = categoryConfiguration => {
  const prefix =
    categoryConfiguration && categoryConfiguration.key != null
      ? String(categoryConfiguration.key)
      : 'categoryLevel';
  const maxLevel = 8;
  const categoryPaths = Array.from(
    { length: maxLevel },
    (_, i) => `publicData.${prefix}${i + 1}`
  );

  return ['description', 'publicData.tags', 'publicData.cardBadge', ...categoryPaths];
};
